<!-- <p class="control-title"><strong>Access required</strong></p>
<ui-searchable-dropdown
    keyName="siteName"
    valueName="siteId"
    dropdownValueName="siteName"
    [placeholderText]="placeholderText()"
    [dataList]="availableLocations"
    [isSiteDropdown]="false"
    [currentValue]="selectedValue"
    [dataFilterConfig]="locationFilterConfig"
    [optionsWidth]="320"
    (onSelect)="onSelectionChange($event)">
</ui-searchable-dropdown> -->
<p class="control-title"><strong>Access required</strong></p>
<div [class.dropdown-disabled-wrapper]="disabled()">
    <ng-multiselect-dropdown
      [placeholder]="'Search by office locations'"
      [data]="availableLocations"
      [(ngModel)]="selectedAccessRequired"
      [settings]="dropdownSettings"
      (onSelect)="onSelectionChange($event)"
      (onDeSelect)="onSelectionChange($event)"
      (onSelectAll)="onSelectAll($event)"
      (onDeSelectAll)="onDeSelectAll($event)">
    </ng-multiselect-dropdown>
</div>